import { render, staticRenderFns } from "./chatroom.vue?vue&type=template&id=0a9b90b3&scoped=true"
import script from "./chatroom.vue?vue&type=script&lang=js"
export * from "./chatroom.vue?vue&type=script&lang=js"
import style0 from "./chatroom.vue?vue&type=style&index=0&id=0a9b90b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b90b3",
  null
  
)

export default component.exports